import React from "react";
import "./Map-Contact.css";
const Map_Contact = () => {
  return (
    <div className="map-wrapper">
      <div className="map-container">
        <div className="container">
          <div className="map-card">
            <iframe
              title="location-map"
              src="https://www.google.com/maps?q=Akshya%20Nagar%201st%20Block%201st%20Cross%20Bangalore&output=embed"
              loading="lazy"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Map_Contact;
